import request from '@/utils/request'

/**
 * 查询主分类商品列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryMainCategoryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.queryMainCategoryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询主分类列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryMainCategory(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.queryMainCategory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加主分类商品
 * @param {Object} data 商品数据
 * @returns {Promise} Promise对象
 */
export function saveMainCategoryProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.saveMainCategoryProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新主分类商品
 * @param {Object} data 商品数据
 * @returns {Promise} Promise对象
 */
export function updateMainCategoryProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.updateMainCategoryProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除主分类商品
 * @param {Object} data 商品数据
 * @returns {Promise} Promise对象
 */
export function deleteMainCategoryProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.deleteMainCategoryProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}